import * as React from "react";
import { SvgIcon, SvgIconProps, createStyles, makeStyles, Theme } from "@material-ui/core";

type Props = SvgIconProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .fil0 ": { fill: "#00AD6C" },
    },
  })
);

function WMLogoOneLiner(props: Props) {
  const c = useStyles();

  return (
    <SvgIcon className={c.root} {...props} viewBox="0 0 9678 833">
      <title>WM Logo</title>
      <g id="Camada_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M8953 2l-35 210c-13,85 -13,190 -18,284l-4 2 -121 -497 -195 1 -114 709 -18 115 18 0 178 -2 38 -242c13,-76 15,-153 23,-229l2 -4 93 475 237 2 133 -824 -217 0z"
        />
        <polygon
          className="fil0"
          points="8485,1 8466,1 8259,1 8158,632 8127,825 8158,824 8354,824 8466,117 "
        />
        <polygon
          className="fil0"
          points="8158,196 8188,2 8157,2 7709,2 7677,203 7802,203 7701,826 7926,826 8028,203 8156,203 "
        />
        <path
          className="fil0"
          d="M7407 279c-4,33 -30,73 -62,92 -15,10 -32,15 -47,13l-15 -1 34 -203c9,0 19,0 28,1 43,8 67,41 62,98zm-62 -276c-4,0 -6,-1 -9,-1l-218 0 -131 824 226 0 36 -220c6,-40 10,-80 14,-121l3 -1 70 342 9 0 236 0 -113 -342c95,-36 152,-123 163,-208 28,-210 -102,-271 -286,-273z"
        />
        <path
          className="fil0"
          d="M6726 354l-6 192 -41 0 -54 0 54 -172 6 -20c18,-53 33,-104 49,-154l1 0c-4,50 -9,111 -9,154zm-47 -352l-48 0 -321 797 -11 27 11 0 221 0 37 -106 111 0 40 0 0 106 233 0 -46 -824 -227 0z"
        />
        <path
          className="fil0"
          d="M6321 2l-11 0 -268 0 -99 287c-13,43 -32,100 -47,153l-1 0 5 -440 -280 0 -231 824 242 0 73 -334c13,-62 22,-122 32,-183l3 0 -4 517 184 0 118 -337c21,-61 38,-121 57,-180l4 0 -63 517 235 0 40 -643 11 -181z"
        />
        <polygon
          className="fil0"
          points="4703,641 4674,825 4703,825 5094,825 5124,631 4932,631 4950,506 5124,506 5156,310 4982,310 5001,196 5195,196 5226,1 4806,1 "
        />
        <polygon
          className="fil0"
          points="4703,188 4733,1 4703,1 4255,0 4222,201 4345,203 4230,825 4471,825 4571,203 4701,203 "
        />
        <polygon className="fil0" points="3849,710 3830,825 3849,825 4056,825 4188,1 3962,1 " />
        <polygon
          className="fil0"
          points="3866,1 3849,1 3640,1 3593,297 3484,297 3531,1 3305,1 3217,553 3174,825 3218,825 3400,825 3453,492 3561,492 3507,825 3733,825 3849,109 "
        />
        <path
          className="fil0"
          d="M3259 1l-42 0 -177 0 -104 333c-17,59 -33,128 -48,180l-3 0c2,-60 3,-120 3,-180l-4 -333 -194 0 -111 333c-19,56 -32,121 -49,183l-2 0c2,-62 6,-121 6,-183l3 -332 -222 0 54 823 219 0 102 -333c21,-67 31,-126 46,-183l2 0c-1,57 -6,121 -5,183l8 333 217 0 259 -709 42 -115z"
        />
        <path
          className="fil0"
          d="M9495 186c44,0 98,37 138,46l45 -181c-53,-26 -129,-50 -194,-50 -82,0 -152,24 -198,69 -44,44 -68,116 -68,184 0,74 46,141 92,183 32,27 92,74 92,130 0,56 -33,70 -81,70 -40,0 -147,-45 -173,-70l-22 219c55,31 131,46 195,46 93,0 175,-24 220,-68 45,-46 81,-116 81,-209 0,-96 -54,-146 -116,-207 -24,-29 -69,-61 -69,-105 0,-41 15,-57 58,-57z"
        />
        <path
          className="fil0"
          d="M276 720c-16,2 -63,38 -63,38 0,0 45,18 67,13 19,-4 64,-37 64,-37 0,0 -45,-17 -68,-14z"
        />
        <path
          className="fil0"
          d="M309 565c-16,2 -62,38 -62,38 0,0 44,18 66,13 20,-4 65,-38 65,-38 0,0 -46,-16 -69,-13z"
        />
        <path
          className="fil0"
          d="M342 409c-16,2 -62,38 -62,38 0,0 44,18 67,13 19,-4 64,-38 64,-38 0,0 -46,-16 -69,-13z"
        />
        <path
          className="fil0"
          d="M382 303c19,-4 64,-37 64,-37 0,0 -45,-17 -68,-14 -16,3 -63,38 -63,38 0,0 45,18 67,13z"
        />
        <path
          className="fil0"
          d="M415 148c20,-4 65,-38 65,-38 0,0 -46,-16 -69,-13 -16,2 -62,38 -62,38 0,0 44,18 66,13z"
        />
        <path
          className="fil0"
          d="M223 59c14,-3 48,-28 48,-28 0,0 -34,-13 -51,-10 -12,1 -47,28 -47,28 0,0 33,14 50,10z"
        />
        <path
          className="fil0"
          d="M188 213c14,-3 48,-28 48,-28 0,0 -34,-12 -52,-10 -12,2 -46,29 -46,29 0,0 33,13 50,9z"
        />
        <path
          className="fil0"
          d="M151 331c-12,2 -47,28 -47,28 0,0 33,14 50,10 15,-3 48,-28 48,-28 0,0 -34,-12 -51,-10z"
        />
        <path
          className="fil0"
          d="M115 484c-12,2 -46,28 -46,28 0,0 33,14 50,10 14,-3 48,-28 48,-28 0,0 -34,-12 -52,-10z"
        />
        <path
          className="fil0"
          d="M82 639c-12,2 -47,29 -47,29 0,0 34,13 50,10 15,-3 49,-29 49,-29 0,0 -35,-12 -52,-10z"
        />
        <path
          className="fil0"
          d="M47 795c-12,1 -47,28 -47,28 0,0 33,13 50,10 14,-3 48,-28 48,-28 0,0 -34,-13 -51,-10z"
        />
        <path
          className="fil0"
          d="M492 765c-20,3 -81,49 -81,49 0,0 58,24 87,17 25,-5 84,-49 84,-49 0,0 -60,-21 -90,-17z"
        />
        <path
          className="fil0"
          d="M525 612c-20,3 -80,49 -80,49 0,0 57,24 86,17 25,-5 84,-49 84,-49 0,0 -60,-21 -90,-17z"
        />
        <path
          className="fil0"
          d="M559 461c-21,3 -81,49 -81,49 0,0 57,24 87,18 25,-6 83,-49 83,-49 0,0 -59,-22 -89,-18z"
        />
        <path
          className="fil0"
          d="M598 377c25,-6 83,-49 83,-49 0,0 -59,-22 -89,-18 -21,3 -81,50 -81,50 0,0 58,23 87,17z"
        />
        <path
          className="fil0"
          d="M629 226c25,-5 83,-49 83,-49 0,0 -59,-21 -89,-17 -21,2 -81,49 -81,49 0,0 58,23 87,17z"
        />
        <path
          className="fil0"
          d="M662 73c25,-5 84,-49 84,-49 0,0 -60,-21 -90,-17 -20,2 -80,49 -80,49 0,0 57,23 86,17z"
        />
        <path
          className="fil0"
          d="M858 160c30,-6 101,-58 101,-58 0,0 -72,-26 -108,-21 -24,3 -97,59 -97,59 0,0 69,28 104,20z"
        />
        <path
          className="fil0"
          d="M814 234c-25,3 -97,59 -97,59 0,0 69,28 104,20 30,-6 100,-58 100,-58 0,0 -71,-26 -107,-21z"
        />
        <path
          className="fil0"
          d="M785 469c30,-7 100,-59 100,-59 0,0 -71,-26 -107,-21 -25,3 -97,59 -97,59 0,0 69,28 104,21z"
        />
        <path
          className="fil0"
          d="M745 622c30,-7 100,-59 100,-59 0,0 -71,-26 -107,-21 -25,3 -97,59 -97,59 0,0 69,28 104,21z"
        />
        <path
          className="fil0"
          d="M703 697c-25,4 -97,59 -97,59 0,0 69,28 104,21 30,-7 100,-59 100,-59 0,0 -71,-26 -107,-21z"
        />
        <path
          className="fil0"
          d="M954 705c36,-8 118,-69 118,-69 0,0 -84,-30 -126,-24 -29,4 -113,69 -113,69 0,0 80,33 121,24z"
        />
        <path
          className="fil0"
          d="M984 459c-29,4 -114,69 -114,69 0,0 81,33 122,24 35,-8 117,-69 117,-69 0,0 -83,-30 -125,-24z"
        />
        <path
          className="fil0"
          d="M909 767c-23,3 -77,41 -101,59l174 1c28,-18 52,-36 52,-36 0,0 -83,-30 -125,-24z"
        />
        <path
          className="fil0"
          d="M1032 399c35,-8 117,-69 117,-69 0,0 -83,-30 -125,-24 -29,4 -114,69 -114,69 0,0 81,33 122,24z"
        />
        <path
          className="fil0"
          d="M1070 244c35,-8 117,-69 117,-69 0,0 -83,-30 -125,-25 -30,4 -114,69 -114,69 0,0 81,33 122,25z"
        />
        <path
          className="fil0"
          d="M1107 88c36,-7 118,-68 118,-68 0,0 -19,-7 -44,-14l-111 0c-36,19 -84,58 -84,58 0,0 80,33 121,24z"
        />
        <path
          className="fil0"
          d="M1146 682c-33,4 -129,78 -129,78 0,0 92,38 138,28 40,-9 134,-79 134,-79 0,0 -95,-34 -143,-27z"
        />
        <path
          className="fil0"
          d="M1195 635c40,-9 134,-79 134,-79 0,0 -95,-34 -143,-27 -33,4 -129,78 -129,78 0,0 91,38 138,28z"
        />
        <path
          className="fil0"
          d="M1224 376c-33,4 -130,78 -130,78 0,0 92,38 139,28 40,-9 134,-79 134,-79 0,0 -96,-34 -143,-27z"
        />
        <path
          className="fil0"
          d="M1261 223c-33,4 -129,78 -129,78 0,0 92,38 138,28 41,-9 134,-79 134,-79 0,0 -95,-34 -143,-27z"
        />
        <path
          className="fil0"
          d="M1308 176c40,-9 134,-79 134,-79 0,0 -95,-34 -143,-27 -33,4 -129,78 -129,78 0,0 92,38 138,28z"
        />
        <path
          className="fil0"
          d="M1543 101c44,-9 147,-86 147,-86 0,0 -12,-4 -30,-9l-174 0c-44,25 -95,65 -95,65 0,0 101,41 152,30z"
        />
        <path
          className="fil0"
          d="M2155 6l-266 0c-39,26 -74,53 -74,53 0,0 1,1 5,3 -29,-7 -59,-10 -80,-7 -37,4 -137,79 -155,93 -31,-8 -66,-14 -90,-10 -36,5 -142,86 -142,86 0,0 101,41 152,30 39,-8 120,-66 142,-82 35,10 76,18 104,12 45,-10 144,-82 161,-94 30,7 62,11 85,6 24,-5 62,-27 97,-49l-7 41 -51 33c-30,-6 -61,-10 -84,-7 -40,5 -148,87 -168,101 -29,-6 -60,-11 -82,-8 -37,5 -136,80 -155,94 -31,-7 -65,-14 -89,-10 -37,5 -143,86 -143,86 0,0 101,41 153,30 38,-8 119,-66 141,-82 35,10 76,18 104,12 42,-9 133,-73 157,-91 33,8 69,13 94,8 26,-6 68,-30 105,-54l-6 32 -66 44c-30,-6 -60,-10 -83,-7 -38,5 -139,80 -164,99 -30,-6 -61,-11 -83,-7 -37,4 -139,81 -156,93 -31,-7 -67,-14 -91,-10 -36,5 -142,86 -142,86 0,0 101,41 152,30 39,-8 121,-67 142,-82 35,10 77,18 106,12 40,-9 126,-69 154,-89 33,8 69,14 94,8 30,-6 80,-37 119,-63l-4 31 -80 52c-31,-6 -62,-10 -84,-7 -40,5 -147,85 -167,101 -29,-6 -59,-10 -81,-7 -35,4 -128,73 -152,91 -31,-7 -66,-14 -90,-10 -37,5 -142,86 -142,86 0,0 100,41 152,30 36,-7 113,-61 138,-80 35,10 77,18 105,12 42,-9 131,-72 157,-90 32,7 67,12 92,7 33,-7 93,-46 134,-74l-4 30 -100 65c-28,-5 -57,-9 -78,-6 -38,5 -141,82 -165,100 -30,-7 -62,-11 -85,-8 -37,5 -139,81 -155,94 -31,-8 -67,-14 -91,-11 -28,4 -97,52 -128,74l221 0c26,-16 49,-33 59,-40 35,10 77,18 105,12 41,-9 128,-69 155,-89 34,8 70,14 96,8 37,-8 108,-54 148,-82l-5 32 -110 72c-30,-6 -60,-9 -83,-6 -35,4 -125,69 -158,94l264 -1c26,-17 51,-34 67,-45l-4 26 -2 0 0 2 -2 0 -3 2 -24 16 169 0 130 -821 -85 0c0,0 0,0 0,0z"
        />
      </g>
    </SvgIcon>
  );
}

export default WMLogoOneLiner;
